import React, {useEffect, useState} from "react";
import { AppBar, Grid, Toolbar } from "@material-ui/core";
import LanguageSelector from "app/MatxLayout/SharedCompoents/LanguageSelector";
import Footer from "app/MatxLayout/SharedCompoents/Footer";
import useAuth from "app/hooks/useAuth";
import { makeStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';
import {FAQAccessLevel, MST_FAQ_ACCESS_TYPE_URL} from "../../../c1utils/const";
import useHttp from "../../../c1hooks/http";
import {getValueBaseOnLanguage} from "../../../c1utils/language";
import {useTranslation} from "react-i18next";
import styled from "styled-components"
import {PDFWrapper} from "../../../portedicomponent/TabsWrapper";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import {previewPDF} from "../../../c1utils/utility";
import {MatxLoading} from "../../../../matx";

const PreWrapper = styled.pre`
  font-family: "Roboto", "Helvetica", "Arial", "sans-serif","Khmer OS Siemreap";
`;

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '100px 30px 0px 30px',
        color: 'black'
    },
    rootAccordion: {
        margin: '30px 30px 0px 30px',
        color: 'black',
        minHeight: '72vh',
    },
    authRoot: {
        margin: '30px 30px 0px 30px',
        color: 'black',
    },
    subContent: {
        marginLeft: '30px'
    },
    link: {
        color: '#551A8B',
        textDecoration:'underline'
    },
    sup: {
        fontSize: '9px'
    },
    heading: {
        fontWeight: 'bold'
    }


}));

const Accordion = withStyles({
    root: {
        border: '1px solid rgba(0, 0, 0, .125)',
        boxShadow: 'none',
        '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
        '&$expanded': {
            margin: 'auto',
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, .03)',
        borderBottom: '1px solid rgba(0, 0, 0, .125)',
        marginBottom: -1,
        minHeight: 56,
        '&$expanded': {
            minHeight: 56,
        },
    },
    content: {
        '&$expanded': {
            margin: '12px 0',
        },
    },
    expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        display: "inherit",
    },
}))(MuiAccordionDetails);

const FAQ = () => {

    const { sendRequest, isLoading, res, urlId } = useHttp();
    const { isAuthenticated } = useAuth();
    const classes = useStyles();
    const [items, setItems] = useState([]);
    const [operation, setOperation] = useState("");
    const { i18n } = useTranslation()

    useEffect(() => {
        sendRequest(`${MST_FAQ_ACCESS_TYPE_URL}`, "getFAQ", "get", {});
        i18n.getDataByLanguage(localStorage.getItem('LANG'))
    }, [sendRequest]);

    useEffect(() => {
        window.dispatchEvent(new Event('storage'))
        if (!isLoading) {
            switch (urlId) {
                case "getFAQ":
                    setItems({...res.data });
                    break;
                default:
                    break;
            }
        }
        let msg = "";
        let severity = "success";

        if ("Delete" === operation) {
            msg = "Delete file successfully!";
        }

        if (res) {
            if ("Download" === operation) {
                viewFile(res.data.faqAttachmentName, res.data.faqAttachment);
            }
        }
    }, [urlId, isLoading, res, operation]);

    const viewFile = (fileName, data) => {
        previewPDF(fileName, data);
    };

    const handleViewFile = (id) => {
        setOperation("Download");
        sendRequest(`/api/pedi/mst/FAQ/file/${id}`);
    };

    const renderItem = (item, idx) => {
        return (
                isLoading? <MatxLoading />: <Accordion key={idx}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header">
                        <Typography className={classes.heading}>{getValueBaseOnLanguage(item, {en: "faqTitleEn", kh: "faqTitleKh"})}</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        {(item?.faqDecEn || item?.faqDecKh) && (
                            <Typography>
                                <PreWrapper key={idx}><br></br>&nbsp;&nbsp;&nbsp;{getValueBaseOnLanguage(item, {en: "faqDecEn", kh: "faqDecKh"})}</PreWrapper>
                            </Typography>
                        )}
                        {item?.faqAttachment && item?.faqAttachmentName && (
                            <PDFWrapper onClick={() => handleViewFile(item?.faqID)}>
                                <PictureAsPdfIcon color={"error"}/>{item?.faqAttachmentName}
                            </PDFWrapper>
                        )}
                    </AccordionDetails>
                </Accordion>
        )
    }

    const newDataSources =  Object.values(items).filter(value => {
        if (isAuthenticated === true){
            return value?.faqAccessLevel !== FAQAccessLevel.P.value;
        } else if (isAuthenticated == false) {
            return value?.faqAccessLevel !== FAQAccessLevel.L.value;
        }
    })

    return (
        <React.Fragment>
            {isAuthenticated ? null : <AppBar position="fixed">
                <Toolbar>
                    <LanguageSelector />
                </Toolbar>
            </AppBar>}
            <Grid container spacing={1}>
                <Grid container item xs={12}>
                    <Grid item xs={12} className={isAuthenticated ? classes.authRoot : classes.root}>
                        <Typography variant="h4">Frequently Asked Questions</Typography>
                    </Grid>
                    <Grid item xs={12} className={isAuthenticated ? classes.authRoot : classes.rootAccordion}>
                        {newDataSources.map((item, idx) => renderItem(item, idx))}
                    </Grid>
                </Grid>
            </Grid>
            {isAuthenticated ? null : <Footer />}
        </React.Fragment>
    );
};


export default FAQ;